module.exports = __webpack_public_path__ + "img/check.4e742f26.png";